import { Link } from 'react-router-dom'

// A row, not a card. Six equal cards read as a catalogue; the customer is
// choosing one service to trust, so the name gets room and the location sits
// quietly beneath it.
//
// The description is what makes that choice possible. Six delivery services in
// one province differ by name and barangay and nothing else on a list — the
// sentence underneath is where a customer finds out that one does wet-market
// runs and another carries LPG tanks. It is the operator's own words, so it is
// set in `ink-2` rather than the quieter `ink-3` the location uses: it is
// content, not metadata.
//
// Clamped to three lines, which holds the whole of a description written to the
// 200-character limit the partner console sets. The clamp is a guard against a
// pathological one, not a routine truncation — a row that grows with whatever
// was typed stops being a row, and the detail page carries the rest.
//
// No `block` on that span: `line-clamp-*` needs its own `display:-webkit-box`
// and the display utility silently wins.
export default function PartnerRow({ partner }) {
  return (
    <Link
      to={`/partners/${partner.slug}`}
      className="group flex items-start justify-between gap-3.5 min-h-[64px] px-1 py-3.5
                 border-b border-hairline transition-[background-color,padding] duration-quick ease-out
                 hover:bg-blush hover:px-2.5"
    >
      <span className="min-w-0 block">
        <span className="block text-body font-semibold text-ink truncate">
          {partner.businessName}
        </span>

        {partner.description && (
          <span className="mt-1 text-body-s text-ink-2 line-clamp-3">
            {partner.description}
          </span>
        )}

        <span className="block mt-1 text-label font-semibold uppercase text-ink-3 truncate">
          {partner.barangay}, {partner.city}
        </span>

        {/* The base rate used to sit here, under the shop name. Removed with the rate
            card on the partner page and for the same reason: a directory row is where
            somebody chooses who to order from, and a base fare is not what that choice
            is made on — it is one term of an arithmetic the summary now does for them,
            exactly, a screen later. */}
      </span>

      <span className="flex-none flex items-center gap-2.5">
        {partner.isActive !== false && (
          <span className="flex items-center gap-[5px] text-label font-semibold uppercase text-brand">
            <span aria-hidden="true" className="w-[5px] h-[5px] rounded-full bg-brand" />
            Open
          </span>
        )}

        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="w-4 h-4 text-ink-3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m9 5 7 7-7 7" />
        </svg>
      </span>
    </Link>
  )
}
